import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { TextNode } from "lexical";
import { $createMergeFieldNode } from "./merge-field-node";

const MERGE_FIELD_REGEX = /\%\%([a-zA-Z0-9_]+)\%\%/g;

export function MergeFieldTransformerPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerNodeTransform(TextNode, (node) => {
      const text = node.getTextContent();

      let match;
      let currentNode = node;

      while ((match = MERGE_FIELD_REGEX.exec(text)) !== null) {
        const [fullMatch, fieldName] = match;
        const matchStart = match.index;
        const matchEnd = matchStart + fullMatch.length;

        const splitNodes = currentNode.splitText(matchStart);
        const afterSplit = splitNodes[1]?.splitText(fullMatch.length);

        if (splitNodes[1]) {
          const mergeNode = $createMergeFieldNode(fieldName);
          splitNodes[1].replace(mergeNode);
        }

        break; // only process one per transform
      }
    });
  }, [editor]);

  return null;
}
